const map = {
	"./100_1441.JPG": 8101,
	"./IMG_2526.jpg": 7971,
	"./IMG_3142.JPG": 1885,
	"./IMG_3153.JPG": 8399,
	"./IMG_3169.JPG": 8988,
	"./IMG_3178.JPG": 6530,
	"./IMG_6254.JPG": 980,
	"./IMG_7291.CR2.jpg": 4768,
	"./IMG_8280.JPG": 5489,
	"./IMG_8284.JPG": 8653,
	"./IMG_8352.CR2.jpg": 4499,
	"./IMG_8426.CR2.jpg": 3733,
	"alumn/100_1441.JPG": 8101,
	"alumn/IMG_2526.jpg": 7971,
	"alumn/IMG_3142.JPG": 1885,
	"alumn/IMG_3153.JPG": 8399,
	"alumn/IMG_3169.JPG": 8988,
	"alumn/IMG_3178.JPG": 6530,
	"alumn/IMG_6254.JPG": 980,
	"alumn/IMG_7291.CR2.jpg": 4768,
	"alumn/IMG_8280.JPG": 5489,
	"alumn/IMG_8284.JPG": 8653,
	"alumn/IMG_8352.CR2.jpg": 4499,
	"alumn/IMG_8426.CR2.jpg": 3733
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3453;